import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const antifraudState = atom<boolean>({
  key: 'antifraudState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
